import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setCurrentStep, setSelectedActivity } from "../../store/MahutiReducer";
import { ELEMENT_LINK, FLOW_TYPE, GET_CAMP_ERR_MSG, scrollToSection } from "../../utils/GlobalParams";
import { getCampainsSF } from "../../utils/sfUtils";
import { mySteps, onBrowserBackButtonHandle } from "../../utils/stepperUtils";
import MahutiActivitiesList from "../mahuti-activities/MahutiActivitiesList";
import './LandingPageStepTwo.css'


function LandingPageStepTwo(props) {

    const store = useSelector(store => store.reducer);
    const [resActivities, setResActivities] = useState([]);
    const [isLoadingActivities, setIsLoadingActivities] = useState(true);
    const [errorMessageHead, setErrorMessageHead] = useState(undefined)

    const refMount = useRef(true);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const getCampains = () => {
        getCampainsSF(store.activityDate, store.visitors)
            .then(res => {
                console.log(res.data.records)
                setResActivities(res.data.records);
                setErrorMessageHead(undefined);
                setIsLoadingActivities(false)
            })
            .catch((err) => {
                setErrorMessageHead(GET_CAMP_ERR_MSG); 
                setIsLoadingActivities(false)
            });
    }


    useEffect(() => {
        if (refMount.current) {
            scrollToSection(ELEMENT_LINK["#sellingflow"])
            refMount.current = false;
            // onrefresh

            if(store.activityDate && store.visitors){
                getCampains()
            }else{
                
            }
            
        }
        return () => {

            onBrowserBackButtonHandle(store, dispatch, navigate, location, () => dispatch(setSelectedActivity(undefined)));
         }
    }, [])
    return <div className="LandingPageStepTwo">
        {errorMessageHead && <div className="alert alert-text">{errorMessageHead}</div>}
        {isLoadingActivities ? <div className="col"><div className="loader" /></div>  : <MahutiActivitiesList tickets={resActivities} />}

    </div>
}


export default LandingPageStepTwo;